<template lang="pug">
  #services.custom-container
    .section-title Seguimiento de tareas
    b-breadcrumb.breadcrumb(:items="breadcrumbs")
    CardResumenTask
    ListBusinessTask()
</template>
<script>
import  ListBusinessTask from '../components/taskTracking/ListBusinessTask';
import  CardResumenTask from '../components/taskTracking/CardResumenTask';

export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Seguimiento de tareas',
          active:true
        },
      ]
    }
  },
  components: {
     ListBusinessTask,
     CardResumenTask
  }
}
</script>
